/* Shop-policy modal — /legal footer links open the store's policy texts
   (Settings → Policies) in a theme-styled dialog. Content is fetched from
   Shopify's own /policies/<handle> pages, so it always mirrors the backend.
   Progressive enhancement: without JS the links navigate to those pages. */
(function () {
  'use strict';

  function modal() { return document.querySelector('[data-policy-modal]'); }

  function open(m) {
    m.hidden = false;
    document.body.classList.add('dm-no-scroll');
    var panel = m.querySelector('.dm-policy-modal__panel');
    if (panel) panel.focus();
  }

  function close(m) {
    m.hidden = true;
    document.body.classList.remove('dm-no-scroll');
  }

  document.addEventListener('click', function (event) {
    var closeBtn = event.target.closest('[data-policy-close]');
    if (closeBtn) {
      var m0 = modal();
      if (m0) close(m0);
      return;
    }

    var link = event.target.closest('[data-policy-link]');
    if (!link) return;
    var m = modal();
    if (!m) return; /* no modal in DOM — let the link navigate */

    event.preventDefault();
    var title = m.querySelector('[data-policy-title]');
    var body = m.querySelector('[data-policy-body]');
    var handle = link.pathname.split('/').pop();
    if (title) title.textContent = '>_ CAT /legal/' + handle;
    if (body) body.innerHTML = '<p>&gt; loading ...</p>';
    open(m);

    fetch(link.href)
      .then(function (response) {
        if (!response.ok) throw new Error(response.status);
        return response.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var content =
          doc.querySelector('.shopify-policy__body') ||
          doc.querySelector('.shopify-policy__container') ||
          doc.querySelector('main');
        if (content && body) {
          body.innerHTML = content.innerHTML;
        } else {
          /* Unexpected markup — go to the full page instead */
          window.location.href = link.href;
        }
      })
      .catch(function () {
        window.location.href = link.href;
      });
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    var m = modal();
    if (m && !m.hidden) close(m);
  });

  /* Links added on the client: Shopify's consent banner can add its own
     "cookie preferences" link; it is not in the server HTML. A foreign link in
     the /legal column, and a footer link with the banner's reopen hash (moved
     into /legal), get the "> LABEL" form of the policy entries. The link keeps
     its node, href and listeners, so the banner still reopens on a click. */
  var CONSENT_HREF = /#shopifyReshowConsentBanner$/;

  /* Styled = exactly one .dm-footer__cmd child, nothing else. A copy of a policy
     entry with new text, or a link whose text is rewritten later, is not. */
  function isStyled(a) {
    var cmd = a.firstElementChild;
    return a.childNodes.length === 1 && cmd && cmd.classList.contains('dm-footer__cmd');
  }

  function normalize(a) {
    if (isStyled(a)) return;
    var text = (a.textContent || '').replace(/^[\s>├└│─]+/, '').trim();
    if (!text) return;
    var cmd = document.createElement('span');
    cmd.className = 'dm-footer__cmd';
    cmd.textContent = '> ' + text.toUpperCase().replace(/\s+/g, '_');
    a.classList.add('dm-footer__entry');
    a.textContent = '';
    a.appendChild(cmd);
  }

  function styleForeignLinks(footer) {
    var legal = footer.querySelector('[data-footer-legal]');
    var links = footer.querySelectorAll('a');
    for (var i = 0; i < links.length; i++) {
      var a = links[i];
      var consent = CONSENT_HREF.test(a.getAttribute('href') || '');
      if (consent) {
        a.removeAttribute('data-policy-link'); /* the modal must not swallow the click */
        if (legal && !legal.contains(a)) legal.appendChild(a);
      }
      if (consent || (legal && legal.contains(a))) normalize(a);
    }
  }

  var footer = document.querySelector('.dm-footer');
  if (footer) {
    styleForeignLinks(footer);
    if (window.MutationObserver) {
      new MutationObserver(function () { styleForeignLinks(footer); })
        .observe(footer, { childList: true, subtree: true, characterData: true });
    }
  }
})();
